import { render, staticRenderFns } from "./CRichText.vue?vue&type=template&id=82c29d48&scoped=true"
import script from "./CRichText.vue?vue&type=script&setup=true&lang=js"
export * from "./CRichText.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CRichText.vue?vue&type=style&index=0&id=82c29d48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c29d48",
  null
  
)

export default component.exports